import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import '../subscriptionform/Subscription.css'
import NewPaymentMethod from './NewPaymentMethod';

const Subscription = () => {
    const [selectedSugarType, setSelectedSugarType] = useState("Sugar Daddy");
  return (
    
    <div className='subscription-section w-100 position-relative'>
        <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
        <div className='subscription-box d-flex flex-wrap align-content-center justify-content-center '>
            <div className='inner-subscription d-flex flex-wrap align-content-center justify-content-center'>
                <div className='subscription-form w-100'>
                    <h6>Subscription</h6>
                    <div className='select-box-sec'>
                        {/* <div className='select-box mb-2 d-flex justify-content-between align-items-center' 
                  data-bs-target="#exampleModalToggle2"
                  data-bs-toggle="modal"> */}
                  <div className='select-box mb-2 d-flex justify-content-between align-items-center' >
                            <div className='left-select d-flex align-items-center gap-3'>
                                <span>Monthly </span>
                                <span>$29.99</span>
                            </div>
                            <div className='right-select'>
                                {/* <Link rel='stylesheet' to='/' className='btn btn-border'>Select</Link> */}
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sugarType" id="sugarDaddy" value="Sugar Daddy" checked={selectedSugarType==="Sugar Daddy" } onChange={()=> setSelectedSugarType("Sugar Daddy")} />
                                    <label className="form-check-label" htmlFor="sugarDaddy"></label>
                                </div>
                            </div>
                        </div>
                        {/* <div className='select-box mb-2 d-flex justify-content-between align-items-center' 
                  data-bs-target="#exampleModalToggle2"
                  data-bs-toggle="modal"> */}
                  <div className='select-box mb-2 d-flex justify-content-between align-items-center'>
                            <div className='left-select d-flex align-items-center gap-3'>
                                <span>Monthly </span>
                                <span>$29.99</span>
                            </div>
                            <div className='right-select'>
                                {/* <Link rel='stylesheet' to='/' className='btn btn-border'>Select</Link> */}
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="sugarType" id="sugarDaddy" value="Sugar Daddy" checked={selectedSugarType==="Sugar Daddy" } onChange={()=> setSelectedSugarType("Sugar Daddy")} />
                                    <label className="form-check-label" htmlFor="sugarDaddy"></label>
                                </div>
                            </div>
                        </div>
                        <p className='mb-0'>*Cancel anytime with no fees! </p>
                    </div>
                    <div className='radio-box-checked'>
                        <h6>Payment Method</h6>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Credit Card</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Apple Pay</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Google Pay</label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Pay Pal</label>
                        </div>
                    </div>
                    <div className='t-and-c-box'>
                        <h6>Terms and Conditions</h6>
                        <div className='form-box'>
                            <textarea className="form-control" id="" rows="5"></textarea>
                        </div>
                        <div className='radio-box-checked p-0 m-0'>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="exampleRadios2" id="" value="option2" />
                                <label className="form-check-label" for="">I have read and accept the terms and conditions</label>
                            </div>
                        </div>
                    </div>
                    <p className='text-center mt-4'><Link rel='stylesheet' to="/new-payment">Next</Link></p>
                </div>
            </div>
        </div>
        {/* <NewPaymentMethod /> */}
    </div>
  )
}

export default Subscription
